'use strict';

angular.module('atex.dam').controller('DamFoldersController', ['$scope', '$rootScope', 'DamFoldersService', '$modal', 'AssignService', '$q', 'DamFileService', 'ContentService', 'UserProfileService',
function($scope, $rootScope, DamFoldersService, $modal, AssignService, $q, DamFileService, ContentService, UserProfileService) {

  $scope.disableUploadToFolderByProfileConfig = false;

  // START Private to upload images
  var uploadImage = function(file, secParentId) {
    return $q.when().then(function() {
      return DamFileService.prepareImageData(file, secParentId).then(function(data) {
        return ContentService.createContent({data : data}).then(function(response) {
          return response.id;
        });
      });
    });
  };

  UserProfileService.getUserProfile({"application": "desk"}).then(function (configuration) {
    $scope.disableUploadToFolderByProfileConfig = (configuration.data['smart-folder-filters'] || {}).disableUpload;
  });

  var uploadImages = function(files, secParentId) {
    return $q.when().then(function() {
      var uploadImagesPromises = files.map(function(file) {
        return uploadImage(file, secParentId);
      });
      return $q.all(uploadImagesPromises).then(function(results) {
        return results;
      });
    });
  };

  var isImageType = function(type) {
    if (type.match('image.*')) {
      return true;
    }
    return false;
  };

  var isLocalImage = function(event) {
    if (event && event.originalEvent.dataTransfer && event.originalEvent.dataTransfer.files && event.originalEvent.dataTransfer.files.length>0) {
      for (var i=0; i<event.originalEvent.dataTransfer.files.length; i++) {
        if (isImageType(event.originalEvent.dataTransfer.files[i].type)) {
          return true;
        }
      }
    }
    return false;
  };

  var filterImages = function(files) {
    var images = [];
    files.forEach(function(file){
      if (isImageType(file.type)) {
        images.push(file);
      }
    });
    return images;
  };
  // END Private to upload files

  $scope.DamFoldersService = DamFoldersService;

  $scope.showSpinner = false;

  $scope.reloadFolders = function() {
    $scope.showSpinner = true;
    DamFoldersService.resetValues();
    DamFoldersService.initializeTree().then(function() {
      $scope.showSpinner = false;
    }).then(null, function(error) {
      $scope.showSpinner = false;
    });
  };

  // Callback
  $scope.nodeSelected = function(node) {
    $rootScope.$broadcast("dam:resetQueuesSelection");
    DamFoldersService.selectedNode = node;
    if (node && !node.isRoot) {
      DamFoldersService.listingFolder = node;
    }
  };

  $scope.canAddFolder = function(smartFolder) {
    if (!DamFoldersService.selectedNode) {
      return false;
    }
    if (DamFoldersService.selectedNode.smartFolder && !smartFolder) {
      // Avoid creation of regular folder under a smart folder [max]
      return false;
    }
    return DamFoldersService.userInfo.isAdm || AssignService.isUserOwner(DamFoldersService.userInfo.externalId, DamFoldersService.userInfo.groups, DamFoldersService.selectedNode.owners);
  };

  $scope.addFolder = function(smartFolder) {
    if (!DamFoldersService.selectedNode) {
      return;
    }
    var folderScope = $rootScope.$new(true);
    // Set only the parentId (from the current folder) on the folder modal dialog Scope
    folderScope.selectedNode = DamFoldersService.selectedNode;
    folderScope.parentId = DamFoldersService.selectedNode.id;
    folderScope.smartFolder = smartFolder;
    var modal = $modal({
      show : true,
      scope : folderScope,
      template : 'views/dam-folder-modal.html',
      modalClass : 'dam-modal-edit confirm-modal ng-cloak',
      backdrop : 'static',
      keyboard : false
    });
    var destroyModal = function() {
      modal.then(function(modalEl) {
        modalEl.on('hidden.bs.modal', function() {
          folderScope.$destroy();
          angular.element(this).remove();
        });
        modalEl.modal('hide');
      });
    };
    folderScope.doCancel = function() {
      destroyModal();
    };
    folderScope.doOk = function(folder) {
      destroyModal();
      DamFoldersService.addFolder(DamFoldersService.selectedNode, folder, false);
    };
  };

  $scope.canEditFolder = function() {
    if (!DamFoldersService.selectedNode) {
      return false;
    }
    return DamFoldersService.userInfo.isAdm || AssignService.isUserOwner(DamFoldersService.userInfo.externalId, DamFoldersService.userInfo.groups, DamFoldersService.selectedNode.owners);
  };

  $scope.editFolder = function() {
    if (!DamFoldersService.selectedNode) {
      return;
    }
    var folderScope = $rootScope.$new(true);
    folderScope.smartFolder = DamFoldersService.selectedNode.smartFolder;
    folderScope.selectedNode = DamFoldersService.selectedNode;
    // Set only the id of the current folder on the folder modal dialog Scope
    folderScope.id = DamFoldersService.selectedNode.id;
    var modal = $modal({
      show : true,
      scope : folderScope,
      template : 'views/dam-folder-modal.html',
      modalClass : 'dam-modal-edit confirm-modal ng-cloak',
      backdrop : 'static',
      keyboard : false
    });
    var destroyModal = function() {
      modal.then(function(modalEl) {
        modalEl.on('hidden.bs.modal', function() {
          folderScope.$destroy();
          angular.element(this).remove();
        });
        modalEl.modal('hide');
      });
    };
    folderScope.doCancel = function() {
      destroyModal();
    };
    folderScope.doOk = function(folder) {
      destroyModal();
      DamFoldersService.selectedNode.name = folder.data.aspects.contentData.data.name;
      DamFoldersService.selectedNode.smartFolder = folder.data.aspects.contentData.data.smartFolder;
      DamFoldersService.selectedNode.folderClosedIconClass = DamFoldersService.selectedNode.smartFolder ? 'fa fa-folder-o' : 'fa fa-folder';
      DamFoldersService.selectedNode.folderOpenIconClass = DamFoldersService.selectedNode.smartFolder ? 'fa fa-folder-open-o' : 'fa fa-folder-open';
      $scope.listNode(DamFoldersService.selectedNode);

      var values = atex.dam.AngularUtils.getTypeValues(folder, "data/aspects/contentData/data/fields") || [];
      DamFoldersService.selectedNode.setTypes(values);
    };
  };

  $scope.canDeleteFolder = function() {
    if ($scope.showSpinner || !DamFoldersService.selectedNode || DamFoldersService.selectedNode.isRoot || (DamFoldersService.selectedNode.children && DamFoldersService.selectedNode.children.length>0)) {
      return false;
    }
    return DamFoldersService.userInfo.isAdm || AssignService.isUserOwner(DamFoldersService.userInfo.externalId, DamFoldersService.userInfo.groups, DamFoldersService.selectedNode.owners);
  };

  $scope.deleteFolder = function() {
    DamFoldersService.deleteFolder(DamFoldersService.selectedNode.id).then(function(response) {
      if (DamFoldersService.selectedNode.parentNode) {
        var indexToRemove = -1;
        DamFoldersService.selectedNode.parentNode.children.forEach(function(child, index) {
          if (child===DamFoldersService.selectedNode) {
            indexToRemove = index;
          }
        });
        if (indexToRemove>=0) {
          DamFoldersService.selectedNode.parentNode.children.splice(indexToRemove, 1);
        }
        DamFoldersService.selectedNode = undefined;
      }
    });
  };

  //Callback
  $scope.expandNode = function(node) {
    if (node.exploring) {
      return;
    }
    node.exploring = true;
    $scope.showSpinner = true;
    DamFoldersService.expandNode(node).then(function(){
      $scope.showSpinner = false;
      delete node.exploring;
    }).then(null, function(error) {
      $scope.showSpinner = false;
      delete node.exploring;
    });
  };

  //Callback
  $scope.droppedOnNode = function(node, event) {
    if (node.isRoot) {
      return;
    }

    $scope.showSpinner = true;

    var eventTxt = event.originalEvent.dataTransfer.getData('Text') || '';
    // If we have text, then it is probably a local drag/drop and we should ignore the file
    if (eventTxt.length === 0 && isLocalImage(event)) {
      var fileList = Array.from(event.originalEvent.dataTransfer.files);
      var images = filterImages(fileList);
      ContentService.getContent({id: node.id}).then(function(folder) {
        var secParentId = atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/p.InsertionInfo/data/securityParentId').value;
        uploadImages(images, secParentId).then(function(results) {
          DamFoldersService.addContentToFolder(results, node, false).then(function(){
            $scope.showSpinner = false;
          }).then(null, function(error) {
            $scope.showSpinner = false;
          });
        });
      });
      return;
    }

    var dragIds = $scope.getIdsFromDragUrl(eventTxt);
    var copy = event.ctrlKey || event.metaKey;
    DamFoldersService.addContentToFolder(dragIds, node, copy).then(function(){
      $scope.showSpinner = false;
    }).then(null, function(error) {
      $scope.showSpinner = false;
    });
  };

  //Callback
  $scope.listNode = function(node) {
    if (node.isRoot) {
      return;
    }
    DamFoldersService.executeQuery(node);
  };

  $scope.canShare = function() {
    if (!DamFoldersService.selectedNode) {
      return false;
    }
    return DamFoldersService.userInfo.isAdm || AssignService.isUserOwner(DamFoldersService.userInfo.externalId, DamFoldersService.userInfo.groups, DamFoldersService.selectedNode.owners);
  };

  $scope.shareFolder = function() {
    var assignScope = $rootScope.$new(true);
    assignScope.id = DamFoldersService.selectedNode.id;
    var modal = $modal({
      show: true,
      scope: assignScope,
      template: 'views/dam-assign.html',
      modalClass: 'dam-modal-assign confirm-modal ng-cloak',
      backdrop: 'static',
      keyboard: false
    });
    var destroyModal = function() {
      modal.then(function(modalEl) {
        modalEl.on('hidden.bs.modal', function() {
          assignScope.$destroy();
          angular.element(this).remove();
        });
        modalEl.modal('hide');
      });
    };
    assignScope.doCancel = function() {
      destroyModal();
    };
    assignScope.doOk = function() {
      destroyModal();
    };
  };

  $scope.canUploadToFolder = function() {
    if ($scope.disableUploadToFolderByProfileConfig || !DamFoldersService.selectedNode || DamFoldersService.selectedNode.isRoot) {
      return false;
    }
    return true;
  };

  $scope.uploadFiles = function(files) {
    var images = filterImages(files);
    if (images.length<=0) {
      return;
    }
    $scope.showSpinner = true;
    var selectedNode = angular.copy(DamFoldersService.selectedNode);
    ContentService.getContent({id: selectedNode.id}).then(function(folder) {
      var secParentId = atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/p.InsertionInfo/data/securityParentId').value;
      uploadImages(images, secParentId).then(function(results) {
        DamFoldersService.addContentToFolder(results, selectedNode, false).then(function(){
          $scope.showSpinner = false;
        }).then(null, function(error) {
          $scope.showSpinner = false;
        });
      });
    }).then(null, function(error) {
      $scope.showSpinner = false;
    });
  };

  // EXPORT / COPY-PASTE (Start)
  $scope.canExportFolder = function() {
    if (!DamFoldersService.selectedNode || !DamFoldersService.selectedNode.id) {
      return false;
    }
    return DamFoldersService.userInfo.isAdm && (DamFoldersService.selectedNode.isRoot || DamFoldersService.selectedNode.parentNode.isRoot);
  };

  $scope.canCopyFolder = function() {
    if (!DamFoldersService.selectedNode || !DamFoldersService.selectedNode.id) {
      return false;
    }
    return DamFoldersService.userInfo.isAdm && !DamFoldersService.selectedNode.isRoot;
  };

  var zip;
  var fileCounter = 1;
  $scope.copiedFolder = [];

  function nextChar(c) {
    return String.fromCharCode(c.charCodeAt(0) + 1);
  }

  var workSubFolders = function(id, subFolderFileNamePrefix, alias, parentAlias) {
    return ContentService.getContent({id: id}).then(function(folder) {

      var nextParentAlias = alias;
      delete folder.data.id;
      delete folder.data.version;
      delete folder.data.meta;
      var operations = [{
        "_type": "com.atex.onecms.content.SetAliasOperation",
        "namespace": "externalId",
        "alias": alias
      }];
      folder.data['operations'] = operations;
      // set correct folder type
      folder.data.aspects.contentData.data._type = "atex.dam.standard.Folder";
      // set the parentId
      folder.data.aspects.contentData.data.parentId = "externalid/" + parentAlias;

      // delete version to avoid re-import issue
      if (folder.data.aspects.contentData) {
        delete folder.data.aspects.contentData.version;
      }
      if (folder.data.aspects['p.InsertionInfo']) {
        delete folder.data.aspects['p.InsertionInfo'].version;
      }
      if (folder.data.aspects['atex.Metadata']) {
        delete folder.data.aspects['atex.Metadata'].version;
      }
      if (folder.data.aspects['atex.dam.standard.ContentAccess']) {
        delete folder.data.aspects['atex.dam.standard.ContentAccess'].version;
      }
      if (folder.data.aspects['atex.OneCMS']) {
        delete folder.data.aspects['atex.OneCMS'].version;
      }

      // Apply options
      if ($scope.exportOptions.overwriteSecParent && $scope.exportOptions.securityParent) {
        atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/p.InsertionInfo/data/securityParentId').value = $scope.exportOptions.securityParent;
        atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/p.InsertionInfo/data/insertParentId').value = $scope.exportOptions.securityParent;
      }
      if ($scope.exportOptions.removeAssignees) {
        if (atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/atex.dam.standard.ContentAccess').value) {
          atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/atex.dam.standard.ContentAccess/data/assignees').value = [];
          atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/atex.dam.standard.ContentAccess/data/assignees_element_types').value = [];
          if ($scope.exportOptions.newCreatorId) {
            atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/atex.dam.standard.ContentAccess/data/creator').value = $scope.exportOptions.newCreatorId;
          }
        }
      }
      if ($scope.exportOptions.clearMetadata) {
        if (atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/atex.Metadata').value) {
          atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/atex.Metadata/data/metadata/dimensions').value = [];
          atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/atex.Metadata/data/metadata/dimensions_element_types').value = [];
        }
      }

      if (zip) {
        zip.file(subFolderFileNamePrefix + (fileCounter++) + "-Folder.json", JSON.stringify(folder.data, null, 2));
      } else {
        $scope.copiedFolder.push(folder.data);
      }

      return DamFoldersService.searchSubFolders(id).then(function(response) {
        if (response.data.response.docs.length<=0) {
          return;
        }
        var nextLevelPrefix = nextChar(subFolderFileNamePrefix);
        var subFoldersPromises = response.data.response.docs.map(function(doc) {
          return workSubFolders(doc.id, nextLevelPrefix, atex.dam.AngularUtils.UUID(), nextParentAlias);
        });
        return $q.all(subFoldersPromises);
      });
    }).then(null, function() {
      console.log("Error getting " + id);
    });
  };

  $scope.exportCopyFolder = function(copy) {
    if (!copy && !$scope.canExportFolder()) {
      return;
    } else if (copy && !$scope.canCopyFolder()) {
      return;
    }
    if ($scope.showSpinner) {
      return;
    }
    fileCounter = 1;
    $scope.showSpinner = true;
    $scope.exportOptions = {};

    if (!copy) {
      zip = new JSZip();
      var modal = $modal({
        show: true,
        scope: $scope,
        template: 'views/dam-folder-export.html',
        modalClass: 'dam-modal-assign confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });
      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      $scope.doCancel = function () {
        destroyModal();
        $scope.showSpinner = false;
      };
    } else {
      $scope.copiedFolder = [];
      zip = null;
    }

    $scope.doExport = function() {
      var selectedNode = angular.copy(DamFoldersService.selectedNode);
      var alias = DamFoldersService.selectedNode.isRoot ? "DeskRootFolder" : atex.dam.AngularUtils.UUID();
      var parentAlias = "";
      if (DamFoldersService.selectedNode.isRoot) {
        parentAlias = "dam.d";
      } else if (DamFoldersService.selectedNode.parentNode.isRoot) {
        parentAlias = "DeskRootFolder";
      }
      workSubFolders(selectedNode.id, "A", alias, parentAlias).then(function() {
        if (zip) {
          zip.generateAsync({type: "blob"}).then(function (content) {
            // see FileSaver.js
            saveAs(content, selectedNode.name + "-folder.zip");
            if (!$scope.$$phase) {
              $scope.$apply(function () {
                $scope.showSpinner = false;
              });
            } else {
              $scope.showSpinner = false;
            }
          });
        } else {
          // Nothing to do, we are ready for a paste
          $scope.showSpinner = false;
        }
      });
      if (!copy) {
        destroyModal();
      }
    };

    if (copy) {
      $scope.doExport();
    }
  };

  $scope.canPasteFolder = function() {
    if (!DamFoldersService.selectedNode || !DamFoldersService.selectedNode.id || $scope.copiedFolder.length<=0) {
      return false;
    }
    var parentToPasteIsSmart = $scope.copiedFolder[0].aspects.contentData.data.smartFolder;
    if (!parentToPasteIsSmart && DamFoldersService.selectedNode.smartFolder) {
      return false;
    }

    return DamFoldersService.userInfo.isAdm;
  };

  var pasteSingleFolder = function(folder) {
    // First execute a get to resolve the parent externalId to a real ContentId
    // It's a pity that we cannot create a content with a reference to an externalId via ContentService [max]
    return ContentService.getContent({id: folder.aspects.contentData.data.parentId}).then(function(resp){
      folder.aspects.contentData.data.parentId = resp.id;
      folder.aspects['p.InsertionInfo'].data.insertParentId = resp.data.aspects['p.InsertionInfo'].data.insertParentId;
      folder.aspects['p.InsertionInfo'].data.securityParentId = resp.data.aspects['p.InsertionInfo'].data.securityParentId;
      return ContentService.createContent({data : folder});
    });
  };

  var pasteFolder = function() {
    var index = 0;
    $scope.copiedFolder[index].aspects.contentData.data.parentId = DamFoldersService.selectedNode.id;

    var cyclFnc = function(resp) {
      if (index===0) {
        // Retrieve all the data to create the new Node
        ContentService.getContent({id: resp.id}).then(function(resp) {
          DamFoldersService.addFolder(DamFoldersService.selectedNode, resp, true);
        });
      }
      if (index===$scope.copiedFolder.length-1) {
        $scope.copiedFolder = [];
        $scope.showSpinner = false;
        return;
      }
      index++;
      return pasteSingleFolder($scope.copiedFolder[index]).then(cyclFnc);
    };

    return pasteSingleFolder($scope.copiedFolder[index]).then(cyclFnc);
  };

  $scope.pasteFolder = function() {
    if (!$scope.canPasteFolder() || $scope.showSpinner) {
      return;
    }
    $scope.showSpinner = true;

    ContentService.getContent({id: DamFoldersService.selectedNode.id}).then(function(resp) {
      // Check if new Parent Types filer can contain the children pasting type
      var parentValidTypes = atex.onecms.ObjectUtils.accessor(resp.data, 'aspects/contentData/data/types').value;
      if (parentValidTypes.length>0) {
        var pastingTypes = atex.onecms.ObjectUtils.accessor($scope.copiedFolder[0], 'aspects/contentData/data/types').value;
        if (pastingTypes.length>0) {
          for (var i = pastingTypes.length-1; i>=0; i-- ) {
            if (_.indexOf(parentValidTypes, pastingTypes[i]) === -1) {
              pastingTypes.splice(i, 1);
            }
          }
        }
      }
      return pasteFolder();
    }).then(null, function() {
      console.log("pasteFolder Error, getting parent node id: " + DamFoldersService.selectedNode.id);
    }).finally(function() {
      $scope.showSpinner = false;
    });
  };

  // EXPORT / COPY-PASTE (End)

}]);
